import { DraftReturnSchema } from "@redotech/redo-return-operations-common/draft-return/draft-return";
import * as z from "zod";

export enum ChangeResetPointErrorCode {
  ReturnNotFound = "ReturnNotFound",
  InvalidResetPoint = "InvalidResetPoint",
}

export const changeResetPoint = {
  name: "changeResetPoint" as const,
  input: z.object({
    draftReturnId: z.string(),
    reset: z.object({
      returnableItemId: z.string(),
      step: z.number(),
      /** @deprecated Ignored; the server derives the flow from the draft. */
      flow: z.any().nullish(),
    }),
  }),
  output: z.object({ draftReturn: DraftReturnSchema }),
};
